// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InfoTooltip__trigger":"bct_a bik_jb bik_qx bik_eg"};